import AppDataService from "./AppDataService";

const COMMON_BASE = "auth";

export default class DashboardService {
  static async getDashboardData() {
    return await AppDataService.get(`dashboard/count`);
  }

  static async getVisitList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.view ? `view=${data.view}` : "",
      data?.include ? `include=${data?.include}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    // return await AppDataService.get(`task${queryString}`);

    return await AppDataService.get(`visit${queryString}`);
  }

  static async getPatientListForDashboard(data) {
    return await AppDataService.get(
      `patient?${data?.searchKey ? "searchKey=" + data?.searchKey : ""}${data?.pageNumber >= 0 ? "&pageNumber=" + data?.pageNumber : ""}${data?.limit ? "&limit=" + data?.limit : ""}`
    );
  }

  static async getTaskListForDashboard(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.status ? `status=${data.status}` : "",
      data?.dueDate ? `dueDate=${data.dueDate}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`task${queryString}`);
  }

  // Top ICD-10 / DSM codes being seen, with the facilities that recorded them.
  // startDate/endDate are UTC ISO instants for the chosen window (calendar day,
  // week, or an IAP operational period). facilityId is optional — omitting it
  // reports across all facilities, so the global facilityId interceptor is
  // skipped and scope is controlled here.
  static async getIcdSummary(data) {
    const queryParams = [
      data?.startDate ? `startDate=${data.startDate}` : "",
      data?.endDate ? `endDate=${data.endDate}` : "",
      data?.facilityId ? `facilityId=${data.facilityId}` : "",
      data?.codeType ? `codeType=${data.codeType}` : "",
      data?.limit ? `limit=${data.limit}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`dashboard/icd-summary${queryString}`, {
      skipFacilityId: true,
    });
  }

  static async getFacilityRooms(data) {
    // facilityId is optional — only send it when a specific facility is selected.
    const queryParams = [data?.facilityId ? `facilityId=${data.facilityId}` : ""]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`dashboard/facility/rooms${queryString}`);
  }
}
